// language=GraphQL
export const ALL_RATIO_CATALOG_BUNDLES_QUERY = `query Query {
  ratioCatalogBundles: ratioCatalogBundles {
    id
    catalogCode
    travelCode
    json
  }
}`

// language=GraphQL
export const SINGLE_RATIO_CATALOG_BUNDLE_QUERY = `query Query($id: ID!) {
  ratioCatalogBundle: ratioCatalogBundle(id: $id) {
    id
    catalogCode
    travelCode
    json
  }
}`

// language=GraphQL
export const CREATE_RATIO_CATALOG_BUNDLE_MUTATION = `
  mutation Mutation($input: CreateRatioCatalogBundleInput) {
    ratioCatalogBundle: createRatioCatalogBundle(input: $input) {
      id
      catalogCode
      travelCode
      json
    }
  }`

// language=GraphQL
export const UPDATE_RATIO_CATALOG_BUNDLE_MUTATION = `
  mutation Mutation($input: UpdateRatioCatalogBundleInput) {
    ratioCatalogBundle: updateRatioCatalogBundle(input: $input) {
      id
      catalogCode
      travelCode
      json
    }
  }`

// language=GraphQL
export const DELETE_RATIO_CATALOG_BUNDLE_MUTATION = `
  mutation Mutation($input: DeleteRatioCatalogBundleInput) {
    deleteRatioCatalogBundle(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_RATIO_CATALOG_BUNDLE_MUTATION = `
  mutation Mutation($input: DeleteRatioCatalogBundleInput) {
    forceDeleteRatioCatalogBundle(input: $input) {
      success
    }
  }`
// language=GraphQL
export const RATIO_CATALOG_BUNDLES_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravels: Boolean = false) {
  groupedDependents: ratioCatalogBundleDependents(id: $id) {
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
  }
}`
